import { render, staticRenderFns } from "./CookInHomeHeader.vue?vue&type=template&id=6897ecc4&scoped=true&"
import script from "./CookInHomeHeader.vue?vue&type=script&lang=ts&"
export * from "./CookInHomeHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CookInHomeHeader.vue?vue&type=style&index=0&id=6897ecc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897ecc4",
  null
  
)

export default component.exports